export const mockData = {
  about: {
    title: "About Our Studio",
    subtitle: "Where creativity meets technology",
    content: [
      "We are a team of passionate designers and developers who believe in the power of thoughtful digital experiences. Founded in 2020, our studio has grown from a small collective to a trusted partner for brands looking to make a meaningful impact online.",
      "Our approach combines strategic thinking with creative execution, ensuring every project not only looks exceptional but performs flawlessly. We specialize in creating websites that are not just visually striking, but also accessible, fast, and conversion-focused.",
      "From startups to established enterprises, we've helped over 200 brands transform their digital presence and connect with their audiences in meaningful ways."
    ],
    stats: [
      { number: "200+", label: "Projects Completed" },
      { number: "50+", label: "Happy Clients" },
      { number: "5", label: "Years Experience" },
      { number: "98%", label: "Client Satisfaction" }
    ]
  },
  
  services: {
    title: "Our Services",
    subtitle: "Comprehensive digital solutions tailored to your needs",
    services: [
      {
        title: "Web Design",
        description: "Beautiful, user-centered designs that captivate and convert your audience.",
        features: [
          "UI/UX Design",
          "Responsive Design",
          "Brand Integration",
          "User Research"
        ],
        icon: (
          <rect x="6" y="6" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="2" fill="none"/>
        )
      },
      {
        title: "Development",
        description: "Fast, secure, and scalable websites built with modern technologies.",
        features: [
          "Frontend Development",
          "Backend Development",
          "CMS Integration",
          "Performance Optimization"
        ],
        icon: (
          <path d="M16 18l6-6-6-6M8 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" fill="none"/>
        )
      },
      {
        title: "Digital Strategy",
        description: "Data-driven strategies to maximize your online presence and ROI.",
        features: [
          "SEO Optimization",
          "Analytics Setup",
          "Conversion Optimization",
          "Performance Monitoring"
        ],
        icon: (
          <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" stroke="currentColor" strokeWidth="2" fill="none"/>
        )
      }
    ]
  },

  footer: {
    description: "Creating exceptional digital experiences that drive results and delight users.",
    socialLinks: [
      {
        platform: "Twitter",
        url: "#",
        icon: (
          <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
        )
      },
      {
        platform: "LinkedIn",
        url: "#",
        icon: (
          <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z M4 2a2 2 0 11-4 0 2 2 0 014 0z"/>
        )
      },
      {
        platform: "Instagram",
        url: "#",
        icon: (
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>,
          <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z M17.5 6.5h.01"/>
        )
      }
    ],
    latestPost: {
      title: "The Future of Web Design: Trends to Watch in 2025",
      excerpt: "Discover the emerging design trends that will shape the digital landscape this year.",
      date: "2025-01-10",
      slug: "future-of-web-design-2025"
    }
  },

  blog: {
    categories: [
      { name: "Design", slug: "design" },
      { name: "Development", slug: "development" },
      { name: "Strategy", slug: "strategy" },
      { name: "Trends", slug: "trends" }
    ],
    posts: [
      {
        id: 1,
        title: "The Future of Web Design: Trends to Watch in 2025",
        slug: "future-of-web-design-2025",
        excerpt: "Explore the cutting-edge design trends that are reshaping how we create digital experiences, from AI-powered layouts to immersive 3D interfaces.",
        content: "Full article content would go here...",
        author: "Sarah Johnson",
        date: "2025-01-10",
        category: "design",
        categoryName: "Design",
        image: "https://images.unsplash.com/photo-1556745757-8d76bdb6984b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MXwxfHNlYXJjaHwxfHxidXNpbmVzc3xlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NTI0NDU2NTl8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 2,
        title: "Building Accessible Websites: A Developer's Guide",
        slug: "building-accessible-websites",
        excerpt: "Learn essential techniques and best practices for creating websites that work for everyone, regardless of their abilities or assistive technologies.",
        content: "Full article content would go here...",
        author: "Mike Chen",
        date: "2025-01-08",
        category: "development",
        categoryName: "Development",
        image: "https://images.unsplash.com/photo-1518672703296-e3022657f7b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxtb2Rlcm58ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzUyNDQ1NjY2fDA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 3,
        title: "Conversion Rate Optimization: Small Changes, Big Results",
        slug: "conversion-rate-optimization",
        excerpt: "Discover how minor adjustments to your website can lead to significant improvements in user engagement and conversion rates.",
        content: "Full article content would go here...",
        author: "Emily Rodriguez",
        date: "2025-01-05",
        category: "strategy",
        categoryName: "Strategy",
        image: "https://images.unsplash.com/photo-1506787497326-c2736dde1bef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxidXNpbmVzc3xlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NTI0NDU2NTl8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 4,
        title: "The Rise of Micro-Interactions in Modern UI",
        slug: "micro-interactions-modern-ui",
        excerpt: "Explore how subtle animations and feedback loops are revolutionizing user experience design and creating more engaging interfaces.",
        content: "Full article content would go here...",
        author: "David Kim",
        date: "2025-01-03",
        category: "trends",
        categoryName: "Trends",
        image: "https://images.unsplash.com/photo-1556745757-8d76bdb6984b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MXwxfHNlYXJjaHwxfHxidXNpbmVzc3xlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NTI0NDU2NTl8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 5,
        title: "Performance Optimization: Making Your Site Lightning Fast",
        slug: "performance-optimization-guide",
        excerpt: "Master the art of web performance with proven techniques to reduce load times and improve user experience across all devices.",
        content: "Full article content would go here...",
        author: "Lisa Park",
        date: "2025-01-01",
        category: "development",
        categoryName: "Development",
        image: "https://images.unsplash.com/photo-1518672703296-e3022657f7b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxtb2Rlcm58ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzUyNDQ1NjY2fDA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 6,
        title: "Brand Storytelling Through Digital Design",
        slug: "brand-storytelling-digital-design",
        excerpt: "Learn how to weave compelling narratives into your digital products to create stronger emotional connections with your audience.",
        content: "Full article content would go here...",
        author: "Alex Thompson",
        date: "2024-12-28",
        category: "design",
        categoryName: "Design",
        image: "https://images.unsplash.com/photo-1506787497326-c2736dde1bef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxidXNpbmVzc3xlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NTI0NDU2NTl8MA&ixlib=rb-4.1.0&q=85"
      }
    ]
  }
};